import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner, finishSpinner } from "./ui/spinner";

export const observacionesTraerStart = () => ({
  type: types.observacionesTraerStart,
});
export const observacionesLimpiar = () => ({
  type: types.observacionesLimpiar,
});
export const observacionesTraerError = (error) => ({
  type: types.observacionesTraerError,
  payload: error,
});
export const observacionesInsertError = (error) => ({
  type: types.observacionesInsertError,
  payload: error,
});
export const observacionesTraerSuccess = (payload) => {
  return {
    type: types.observacionesTraerSuccess,
    payload: payload,
  };
};
export const startDeletingObservacion = (idItem) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `ObservacionesAfiliado/${idItem}`,
        "",
        "DELETE"
      );
      if (response.ok) {
        dispatch(observacionDeleted(idItem));
      } else {
        throw new Error(response);
      }
      dispatch(finishSpinner());
    } catch (error) {
      console.log("error en delete observacion", error);
    }
  };
};
const observacionDeleted = (idItem) =>{
    return {
        type: types.observacionesDeleted,
        payload: idItem,
      };
}
export const observacionesInsertSuccess = (payload) => {
  return {
    type: types.observacionesInsertSuccess,
    payload: payload,
  };
};
export const observacionesInsertStart = (observacion) => {
    //console.log(observacion);
  return async (dispatch, getState) => {
    try {
      const { afiliado } = getState().afiliacion;
      //const { idUsuario,userName } = getState().auth;
      const observacionMandar = {
        idAfiliado: afiliado.id_afiliado,
        descripcionObservacion: observacion,
        // usuario:{
        //     userName:userName,
        //     idUsuario:idUsuario
        // }
      };
      dispatch(startSpinner());
      const response = await fetchConToken(
        `ObservacionesAfiliado`,
        observacionMandar,
        "POST"
      );
      //console.log(response);
      if (response.ok) {
      
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const obs = await response.json();
          dispatch(observacionesInsertSuccess(obs));
        } else {
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      //alertError(error);
      console.log("error en insert observaciones", error);
    }
  };
};
export const fetchObservaciones = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(observacionesTraerStart());
    const response = await fetchConToken(`ObservacionesAfiliado/${idAfiliado}`);
    if (!response.ok) {
      dispatch(observacionesTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      // if (lista.length > 0) {
        dispatch(observacionesTraerSuccess(lista));
      // }
    }
    dispatch(finishSpinner());
  };
};
